class Config {
    static apiUrl = 'https://yaver.xyz/api/admin';
    static cookieName = 'access_jwt';
  }
  export default Config;
